import ogs from 'open-graph-scraper';
import urlParser from 'url';

const api = 'https://voray-cors-anywhere.herokuapp.com';

function getUrlDomain(url) {
  const urlObj = urlParser.parse(url);
  return urlObj.host;
}

function buildOgObject(statusCode, result) {
  let meta = statusCode === 200 ? result.data : null;

  if (meta) {
    let images = meta.ogImage;

    if (images instanceof Array) {
      meta.ogImage = images[0];
    }

    let domain = meta.ogUrl;

    if (domain) {
      meta.ogUrl = getUrlDomain(meta.ogUrl);
    }
  }

  return {
    statusCode,
    meta,
    error: statusCode !== 200 ? result.error : null
  };
}

export default function (targetUrl, callback) {
  const url = `${api}/${targetUrl}`;

  fetch(url, {
    headers: {
      'Origin': window.origin,
      'Accept': 'text/html'
    },
  })
    .then(response => response.text())
    .then(html => {
      ogs({ html }, (error, results) => {
        const statusCode = results.success ? 200 : 500;
        callback(buildOgObject(statusCode, results));
      });
    });
}
